import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { openLoginModal, openSignUpModal } from '../../../redux/modules/modal';
import { useAppDispatch } from '@/redux/hooks';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

const LoggedOut = () => {
    const dispatch = useAppDispatch();

    const loginModal = React.useCallback(() => dispatch(openLoginModal()), [dispatch]);

    const signUpModal = React.useCallback(() => dispatch(openSignUpModal()), [dispatch]);

    return (
        <StyledLoggedOut>
            <StyledLink onClick={loginModal} primaryWeak>
                <FormattedMessage id="log_in" />
            </StyledLink>
            <StyledButton onClick={signUpModal} primary testid="headerJoinButton">
                <FormattedMessage id="sign_up" />
            </StyledButton>
        </StyledLoggedOut>
    );
};

export default LoggedOut;

const StyledLoggedOut = styled.div`
    margin-left: 12px;
`;

const StyledLink = styled(Link)`
    && {
        font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
        margin-right: 1.5em;
        line-height: 43px;
        text-transform: uppercase;
        display: block;
        float: left;

        @media (max-width: 991px) {
            font-size: 12.6px;
            font-weight: normal;
            margin-right: 10px;
        }
    }
`;
const StyledButton = styled(Button)`
    && {
        display: inline-flex;
        float: left;

        @media (max-width: 991px) {
            padding: 0 13px;
        }
    }
`;
